import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Report } from 'app/models/report.model';

declare var $: any;
declare var Stimulsoft: any;
declare var System: any;


@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {

  viewer: any;
  konReport: Report;
  stiReport: any;

  constructor(
    private route: ActivatedRoute,
    ) { }

  ngOnInit() {

    //if there is a report in the session storage then show it
    this.konReport = JSON.parse(sessionStorage.getItem('report'));

    if (this.konReport){
      this.generateReport();
      this.viewReport();
    }

  }
  generateReport(){

    // Report viewer options
    var options = new Stimulsoft.Viewer.StiViewerOptions();
    options.appearance.openLinksWindow = '_blank';
    options.appearance.scrollbarsMode = true;
    options.appearance.fullScreenMode = true;

    this.viewer = new Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false);

    this.stiReport = new Stimulsoft.Report.StiReport();

    // load resource file Report.mrt that is the report's design
    this.stiReport.loadFile('./assets/report/Report.mrt');

    // retrive page info. We need to calculate the page width
    var page = this.stiReport.pages.getByIndex(0);

    // retrive dataBand from Report.mrt. This is the data container
    var dataBand = this.stiReport.getComponents().getByName('DataBand1');

    // retrive headerBand from Report.mrt. This is the header container (logo left, company name right)
    var headerBand2 = this.stiReport.getComponents().getByName('PageHeaderBand2');

    var tempColumnWidthStandard = Stimulsoft.Base.StiAlignValue.alignToMinGrid(page.width / this.konReport.columns.length, 0.1, false);

    // setting columns width
    for (var i = 0; i < this.konReport.columns.length; i++){
      this.konReport.columns[i].width = tempColumnWidthStandard;
    }

    var columnHeight = 1.5;
    var pos = 0;


    // HEADER
    for (var i = 0; i < this.konReport.columns.length; i++){
      var headerText = new Stimulsoft.Report.Components.StiText();
      headerText.clientRectangle = new Stimulsoft.System.Drawing.Rectangle(pos, 0, this.konReport.columns[i].width, 1.0);
      headerText.text = this.konReport.columns[i].title;
      headerText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
      headerText.vertAlignment = 1;
      headerText.name = 'HeaderText_' + i;
      headerText.border.side = Stimulsoft.Base.Drawing.StiBorderSides.All;
      headerText.font = new Stimulsoft.System.Drawing.Font('Calibri', 11, 1);
      headerText.textOptions.wordWrap = true;
      headerBand2.components.add(headerText);
      pos = pos + this.konReport.columns[i].width;
    }

    // DATA
    var y = 0;
    for (var i = 0; i < this.konReport.data.length; i++){
      var x = 0;

      for (var j = 0; j < this.konReport.columns.length; j++){

        //Create text on Data Band
        var dataText = new Stimulsoft.Report.Components.StiText();
        dataText.clientRectangle = new Stimulsoft.System.Drawing.Rectangle(x, y, this.konReport.columns[j].width, columnHeight);
        dataText.text = this.konReport.data[i][this.konReport.columns[j].field] ? this.konReport.data[i][this.konReport.columns[j].field].toString() : '';

        if (this.konReport.columns[j].alignData == 'left'){
          dataText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Left;
        }
        else if (this.konReport.columns[j].alignData == 'center'){
          dataText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Center;
        }
        else if (this.konReport.columns[j].alignData == 'right'){
          dataText.horAlignment = Stimulsoft.Base.Drawing.StiTextHorAlignment.Right;
        }

        dataText.textOptions.wordWrap = true;
        dataText.canGrow = true;
        dataText.name = 'DataText_' + i + '_' + j;
        dataText.margins.left = 10;
        dataText.margins.right = 10;
        dataText.margins.top = 10;
        dataText.margins.bottom = 10;

        // Add condition alternate color row
        if (i % 2 == 1){
          var condition = new Stimulsoft.Report.Components.StiCondition();
          condition.backColor = Stimulsoft.System.Drawing.Color.fromArgb(209, 209, 209);
          condition.textColor = Stimulsoft.System.Drawing.Color.black;
          condition.expression = '(Line & 1) == 1';
          condition.item = Stimulsoft.Report.Components.StiFilterItem.Expression;
          dataText.conditions.add(condition);
        }

        dataBand.components.add(dataText);
        x = x + this.konReport.columns[j].width;
      }
      y = y + columnHeight;
    }

    // var imageLogo = this.stiReport.getComponents().getByName('ImageLogo');
    // var baseURI = window.document.baseURI;

    var varInfoCompany = this.stiReport.dictionary.variables.getByName('var_company');
    var varImage = this.stiReport.dictionary.variables.getByName('var_image');
    var stiImage;
    if (this.konReport.company['id'] && this.konReport.company['id'] > 0) {

      stiImage = Stimulsoft.System.Drawing.Image.fromFile('./assets/layout/images/' + this.konReport.company['id'] + '.png');
      varImage.valueObject = stiImage;

      varInfoCompany.valueObject = this.konReport.company['name'];

    } else {
      varInfoCompany.valueObject = 'Nessuna informazione sull\'azienda';
      stiImage = Stimulsoft.System.Drawing.Image.fromFile('./assets/report/defaultLogo.png');
      varImage.valueObject = stiImage;
    }
  }

  /*** get the report object in the session storage and generate report ***/
  viewReport(){

     // Render report
    this.stiReport.render();

    this.viewer.report = this.stiReport;

    var self = this;

    setTimeout(() => {
      self.viewer.renderHtml('viewerContent');
    }, 100);

  }

}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/report/report.component.ts